import React from "react";
import { Container, Wrapper, Title, Heading, Button } from "./style";

const Hero = () => {
  return (
    <Container>
      <Wrapper>
        <Title>It's great to be home!</Title>
        <Heading>
          Making <Heading yellow>Good</Heading> things happen.
        </Heading>
        <Button>READ MORE</Button>
      </Wrapper>
    </Container>
  );
};

export default Hero;
